import {Action} from '@ngrx/store';
import * as _ from 'lodash';

import {LoadMyClientsSuccessAction, myClientsActionTypes} from '../actions/my-clients';
import {Client} from '../models/client';

export interface MyClientsState {
  array: Client[];
}

const initialState: MyClientsState = {
  array: []
};

export function myClientsReducer(state: MyClientsState = initialState, action: Action): MyClientsState {
  switch (action.type) {
    case myClientsActionTypes.LOAD:
      return handleLoadAction();
    case myClientsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case myClientsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): MyClientsState {
  return initialState;
}

function handleLoadSuccess(state: MyClientsState, action: LoadMyClientsSuccessAction): MyClientsState {
  const newState = _.clone(state);
  newState.array = action.payload || [];
  return newState;
}

function handleLoadFailAction(state: MyClientsState): MyClientsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const myClientsSelectors = {
  array: (state: MyClientsState) => _.get(state, 'array', [])
};
